export default class Entity {
    dbId?: string
    createdAt?: Date
    updatedAt?: Date

    constructor() {
    }
}